/* Giftiliya – merged logo picker for Zepto Product Personalizer
 * Merges "Upload your logo" into "Choose your logo" as one captioned grid:
 * [preset logos…] [Upload yours]
 * Required mode (window.GL_LOGO_REQUIRED, set per product in snippets/giftiliya-logo-picker.liquid):
 *   no "No logo" tile, Add to cart / Buy it now blocked until a preset is picked or a file is uploaded.
 * Optional mode: "No logo" tile shown, no blocking.
 * Only one source can be active: picking a preset removes an uploaded file and vice versa.
 */
(function () {
  'use strict';
  var UP_SEL = '.pplr-wrapper[class*="upload-your-logo"]';
  var CH_SEL = '.pplr-wrapper[class*="choose-your-logo"]';
  var REQUIRED = window.GL_LOGO_REQUIRED === true;

  function q(el, s) { return el ? el.querySelector(s) : null; }
  function qa(el, s) { return el ? Array.prototype.slice.call(el.querySelectorAll(s)) : []; }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  // Zepto renders an uploaded file as li.pplr_img_w (thumb a.pplr_img, delete a.pplr_delete)
  function hasUpload(up) { return !!q(up, '.pplr_img_w'); }
  // Zepto swaps the <input type=file> after a delete, so always look it up fresh
  function fileInput(up) { return q(up, 'input[type=file]'); }

  function removeUpload(up) {
    qa(up, '.pplr_img_w .pplr_delete').forEach(function (del) { del.click(); });
  }

  function deselectPreset(ch) {
    var sel = q(ch, '.pplr-swatch-element.selected:not(.pplr_deselect)');
    var d = q(ch, '.pplr_deselect');
    if (sel && d) d.click();
  }

  function sync(ch, up) {
    var tile = q(ch, '.gl-upload-tile');
    var none = q(ch, '.pplr_deselect');
    if (!tile) return;
    var uploaded = hasUpload(up);
    var preset = !!q(ch, '.pplr-swatch-element.selected:not(.pplr_deselect)');
    tile.classList.toggle('gl-active', uploaded);
    var thumb = q(up, '.pplr_img_w .pplr_img');
    var tbg = thumb ? getComputedStyle(thumb).backgroundImage : 'none';
    var bg = (uploaded && tbg && tbg !== 'none') ? tbg : '';
    var holder = q(tile, '.gl-upload-thumb');
    if (holder.style.backgroundImage !== bg) holder.style.backgroundImage = bg;
    // toggle(x, bool) is a no-op when unchanged – add/remove would re-fire the observer forever
    tile.classList.toggle('gl-has-thumb', !!bg);
    setText(q(tile, '.gl-upload-text'), uploaded ? 'Change' : 'Upload');
    setText(q(tile, '.gl-cap'), uploaded ? 'Your logo' : 'Upload yours');
    if (none) none.classList.toggle('gl-active', !uploaded && !preset);
    var status = q(ch, '.gl-logo-status');
    if (status) {
      var name = preset ? (q(ch, '.pplr-swatch-element.selected .gl-cap') || {}).textContent : '';
      setText(status, uploaded ? 'Your logo is uploaded ✓' : preset ? ('Selected: ' + (name || 'logo')) : (REQUIRED ? 'Choose a logo or upload yours' : 'No logo selected'));
    }
    if (uploaded || preset) ch.classList.toggle('gl-error', false);
  }

  function init() {
    var ch = document.querySelector(CH_SEL);
    var up = document.querySelector(UP_SEL);
    if (!ch || !up || ch.dataset.glMerged) return;
    var grid = q(ch, '.pplr-swatch-main');
    if (!grid || !fileInput(up)) return;
    ch.dataset.glMerged = '1';
    document.documentElement.classList.add('gl-logo-merged');
    if (REQUIRED) document.documentElement.classList.add('gl-logo-required');

    // Header copy
    var label = q(ch, '.pplrlabel');
    if (label && !q(label, '.gl-sub')) {
      var first = label.firstChild;
      if (first && first.nodeType === 3) first.nodeValue = 'Add your logo ';
      var opt = document.createElement('span');
      opt.className = REQUIRED ? 'gct-required gl-required' : 'gl-optional';
      opt.textContent = REQUIRED ? 'Required' : 'Optional';
      label.appendChild(opt);
      var sub = document.createElement('span');
      sub.className = 'gl-sub'; sub.textContent = 'Pick a logo below or upload your own';
      label.appendChild(sub);
    }

    // Visible captions under every preset tile
    var NICE = { 'government-officer': 'Govt. Officer', 'ca': 'CA' };
    qa(grid, '.pplr-swatch-element:not(.pplr_deselect)').forEach(function (sw) {
      if (q(sw, '.gl-cap')) return;
      var raw = ((q(sw, '.swtooltip') || {}).textContent || (q(sw, '.img_dropdown') || {}).textContent || '').trim();
      var cap = document.createElement('span');
      cap.className = 'gl-cap';
      cap.textContent = NICE[raw.toLowerCase()] || raw.replace(/-/g, ' ');
      sw.appendChild(cap);
      sw.setAttribute('aria-label', cap.textContent + ' logo');
    });

    // Upload tile
    var tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'gl-tile gl-upload-tile';
    tile.setAttribute('aria-label', 'Upload your own logo');
    tile.innerHTML = '<span class="gl-upload-thumb"></span>' +
      '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 16V4m0 0l-5 5m5-5l5 5M4 20h16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span class="gl-upload-text">Upload</span><span class="gl-cap">Upload yours</span>';
    var desel = q(grid, '.pplr_deselect');
    grid.insertBefore(tile, desel || null);
    if (desel) {
      desel.setAttribute('title', 'No logo'); desel.setAttribute('aria-label', 'No logo');
      if (!q(desel, '.gl-cap')) {
        desel.insertAdjacentHTML('beforeend', '<span class="gl-none-icon" aria-hidden="true">⊘</span><span class="gl-cap">No logo</span>');
      }
    }

    var status = document.createElement('div');
    status.className = 'gl-logo-status';
    status.setAttribute('aria-live', 'polite');
    grid.parentNode.insertBefore(status, grid.nextSibling);

    // Move the upload block under the grid (keeps Zepto's file row, crop & delete working)
    status.parentNode.insertBefore(up, status.nextSibling);
    up.classList.add('gl-upload-inline');

    var err = document.createElement('div');
    err.className = 'gl-logo-error';
    err.setAttribute('role', 'alert');
    err.textContent = 'Please choose a logo or upload yours';
    status.parentNode.insertBefore(err, status.nextSibling);

    // Block Add to cart / Buy it now until a logo is chosen. Window-level capture runs before Zepto/theme handlers.
    function hasLogo() { return hasUpload(up) || !!q(ch, '.pplr-swatch-element.selected:not(.pplr_deselect)'); }
    function block(e) {
      if (!REQUIRED || hasLogo()) return;
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      ch.classList.toggle('gl-error', true);
      ch.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var form = ch.closest('form') || document.querySelector('form[action*="/cart/add"]');
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[name="add"], [type="submit"], .p_a_t_c, .shopify-payment-button__button');
      if (b && form && (b.form === form || form.contains(b) || b.classList.contains('shopify-payment-button__button'))) block(e);
    }, true);
    window.addEventListener('submit', function (e) { if (e.target === form) block(e); }, true);

    tile.addEventListener('click', function () { var fi = fileInput(up); if (fi) fi.click(); });

    // Drag & drop onto the tile
    ['dragenter', 'dragover'].forEach(function (ev) {
      tile.addEventListener(ev, function (e) { e.preventDefault(); tile.classList.add('gl-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      tile.addEventListener(ev, function () { tile.classList.remove('gl-drag'); });
    });
    tile.addEventListener('drop', function (e) {
      e.preventDefault();
      if (!e.dataTransfer || !e.dataTransfer.files.length) return;
      var fi = fileInput(up);
      try {
        var dt = new DataTransfer(); dt.items.add(e.dataTransfer.files[0]);
        fi.files = dt.files;
        fi.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (err) { if (fi) fi.click(); }
    });

    // Uploading a file clears the preset logo (delegated: the input element gets replaced)
    up.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.type === 'file' && t.files && t.files.length) deselectPreset(ch);
    }, true);

    // Picking a preset (or "No logo") clears the uploaded file
    grid.addEventListener('click', function (e) {
      if (e.target.closest('.gl-upload-tile')) return;
      var sw = e.target.closest('.pplr-swatch-element');
      if (!sw) return;
      if (hasUpload(up)) removeUpload(up);
      setTimeout(function () { sync(ch, up); }, 50);
    }, true);

    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; sync(ch, up); });
    }).observe(ch, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style'] });
    sync(ch, up);
  }

  function boot() {
    init();
    var tries = 0;
    var t = setInterval(function () {
      init();
      if (document.documentElement.classList.contains('gl-logo-merged') || ++tries > 40) clearInterval(t);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
